// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contentwrapper[data-v-76858011]{display:block;text-overflow:ellipsis;word-wrap:break-word;overflow:hidden;line-height:1.8em;max-height:12.6em}.contentwrapper.expand[data-v-76858011]{overflow:unset;max-height:unset!important}", ""]);
// Exports
module.exports = exports;
